<template>
    <Header
        elements="9"
        current="4"
    ></Header>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <div class="checkDetail">
                            <h1>
                                Does your office action mention a "likelihood of confusion" to another trademark?
                                <Popper>
                                    <span class="GetHelpItem">
                                        <span class="popover-icon">
                                            <i class="fa fa-question-circle" aria-hidden="true"></i>
                                        </span>
                                        Get Help
                                    </span>
                                    <template #content>
                                        <div class="popper-content">
                                            <b>What is likelihood of confusion?</b>
                                            <p>A “likelihood of confusion” occurs when the Trademark office believes that your mark is confusingly similar to other trademarks that the government has already granted, the similarity between your products/services.</p>
                                        </div>
                                    </template>
                                </Popper>
                            </h1>
                            <div class="MuiBox-root css-1rrbnz">
                                <RadioCheckbox
                                    :value="params.is_likelihood_of_confusion"
                                    @change_c="changeParams($event)"
                                    type="radio"
                                    value_v="No"
                                    text="No"
                                    name="is_likelihood_of_confusion"
                                ></RadioCheckbox>
                                <RadioCheckbox
                                    :value="params.is_likelihood_of_confusion"
                                    @change_c="changeParams($event)"
                                    type="radio"
                                    value_v="Yes"
                                    text="Yes"
                                    name="is_likelihood_of_confusion"
                                ></RadioCheckbox>
                                <RadioCheckbox
                                    :value="params.is_likelihood_of_confusion"
                                    @change_c="changeParams($event)"
                                    type="radio"
                                    value_v="Not_Sure"
                                    text="Not Sure"
                                    name="is_likelihood_of_confusion"
                                ></RadioCheckbox>
                            </div>

                            <div v-if="params.is_likelihood_of_confusion == 'No'" id="ans_1_0" class="ans_1" style="">
                                <div class="inputSec">
                                    <p>Excellent! This means that the government does not think your trademark is confusingly similar to other trademarks. Please click “Next” below so we can proceed to the next step.</p>
                                </div>
                            </div>
                            <div v-else-if="params.is_likelihood_of_confusion == 'Yes'" id="ans_1_1" class="ans_1">
                                <div class="inputSec">
                                    <p class="d-block mb-12">
                                        That's ok. This means that the USPTO believes that there is a superficial similarity between your trademark and another trademark/s, given the products/services each respective party is selling. To handle “Substantive Office Actions”, which require drafting legal briefs, we charge a legal service fee of $850.
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="params.is_likelihood_of_confusion == 'Not_Sure'" id="ans_1_2" class="ans_1">
                                <div class="inputSec">
                                    <p>Ok, no problem at all. We'll review your Office Action for you and contact you to discuss any outstanding matters after you finish onboarding with us.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <BottomButton
                        :active="true"
                        @click.native="back"
                        text="Back"
                        class_b="button-back"
                    ></BottomButton>
                    <BottomButton
                        :active="true"
                        @click.native="next"
                        text="Next"
                        class_b="button-next"
                    ></BottomButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import TextareaElement from '@/ui/Input-Textarea.vue'
import RadioCheckbox from '@/ui/Radio-Checkbox.vue'
import http from "@/api/http";
import BottomButton from '@/ui/Bottom-Button.vue'
import Freezeframe from '@/components/Freezeframe.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        BottomButton,
        RadioCheckbox,
        TextareaElement,
        Freezeframe
    },
    data() {
        return {
            params: {
                is_likelihood_of_confusion: 'No',
                number: '',
            }
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init() {
            let { data } = await http.get('trademark-office-action/step-2/' + this.$route.params.key);

            if (data.res) {
                this.params = data.data.data

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
        async changeParams(value) {
            this.params.is_likelihood_of_confusion = value

            let { data } = await http.put('trademark-office-action/step-2/' + this.$route.params.key, this.params);

            if (data.res) {
                this.init()
            }
        },
        async next() {
            this.$router.push({ path: '/trademark-office-action/step-3/' + this.$route.params.key })
        },
        back() {
            this.$router.push({ path: '/trademark-office-action/step-1/' + this.params.number })
        }
    }
}
</script>
